<script>


  import config from '../../libs/config.js';
  import func from '../../libs/functions.js';
  import api from '../../api'
  import _ from 'lodash'

  import tippy from 'tippy.js'

  import iziToast from 'izitoast'
  import 'izitoast/dist/css/iziToast.min.css';

  import _system from '../../libs/system';

	import { mapGetters, mapActions } from 'vuex'

   import { db } from '../../firebase';
	
	export default 
	{
    name: 'Workspace',
		data() 
        {
        	return {
            func: func,
            attachmentPreview: '',
            attachment: {},
            showMenu: {
              deleteWs: ''
            },
            color: '',
            loading: false
        	}
        },
        computed: {
          ...mapGetters('session', ['isLoggedIn', 'getUser', 'getRole']),
          ...mapGetters('networks', ['networksById']),
          ...mapGetters('workspaces', ['currentWorkspace','workspaces', 'workspacesById']),
          ...mapGetters('tags', ['tags', 'tagsByName', 'tagsByTypeName']),  
          ...mapGetters('workspaceusers', ['workspaceusers']),
          ...mapGetters('accounts', ['accounts']),
          image(){
            if(this.attachmentPreview.length) {
              return this.attachmentPreview;
            }else if(this.currentWorkspace.avatar && this.currentWorkspace.avatar.data){
              return 'data:'+ this.currentWorkspace.avatar.contentType +';base64,' + this.currentWorkspace.avatar.data.toString('base64');
            }else{
              return '/img/avatar/roboto/128/latin_'+ func.getFirstLetter(this.currentWorkspace.name) +'.png'
            }  
          }
        },
      methods: {
        ...mapActions('session', ['setUser']),
        ...mapActions('workspaces', ['setWorkspaces']),
        ...mapActions('workspaceusers', ['setWorkspaceusers']),
        onChildUpdate (newValue) {
          console.log(newValue);
        },
        deleteWorkspace(ws, status){

        if(!status) return this.showMenu.deleteWs = ws._id //Only open
        if(status == 'no') return this.showMenu.deleteWs = ''

        const payload = {
          query: {
            workspaceId: ws._id
          }
        }

        _system.services.workspaces.delete(payload, (err, workspaces) => {
          if(err) return err.message;

             location.replace('https://app.juphy.com/signin?system=reset'); 

        })

      },
        update(){

          if(this.currentWorkspace.name.length < 2) return alert('Type at least 2 character!');

          this.loading = true;
          let payload = {
            query: {
              workspaceId: this.currentWorkspace._id
            },
            body: {
              name: this.currentWorkspace.name
            }
          }
          _system.services.workspaces.update(payload, (err, res) => {
            if(err) return alert(err.message);


            payload.body = {
              color: this.color
            }

            _system.services.workspaces.updateColor(payload, (err, res) => {
              if(err) return alert(err.message);


            });

             if(this.attachmentPreview.length){
              const formDataImage = new FormData();
              formDataImage.append('file', this.attachment);

              payload.body = {}
              payload.formData = formDataImage

              _system.services.workspaces.updateAvatar(payload, (err, res) => {
                if(err) return alert(err.message)

                this.loading = false;
                    iziToast.success({
                      position: 'bottomCenter',
                      title: 'Updated',
                  });

              });
             }else{
               this.loading = false;
                  iziToast.success({
                      position: 'bottomCenter',
                      title: 'Updated',
                  });
             }
          })
        },
        upload(){
          document.getElementById('upload').click();
        },
        onFileChange(e){
          var files = e.target.files || e.dataTransfer.files;
          
          if(files[0] && files[0].size > 500000){
            return alert('Image size must be less than  500 kb')
          }

          var image = new Image();
          var reader = new FileReader();

          this.attachment = files[0];

          reader.onload = (e) => {
            console.log(e)
            this.attachmentPreview = e.target.result;

                let index = _.findIndex(this.workspaces, {_id: this.currentWorkspace._id});

/* 
                if(this.workspaces[index].color){
                  this.workspaces[index].color = this.currentWorkspace.color
                } */
/*                 this.workspaces[index].avatar = {
                  contentType: e.target.result.split(',')[0].split(';')[0].slice(5),
                  data: e.target.result.split(',')[1]
                  } */

                  let newObj = Object.assign({}, this.workspaces[index])

                  newObj.avatar = {
                  contentType: e.target.result.split(',')[0].split(';')[0].slice(5),
                  data: e.target.result.split(',')[1]
                  }

                this.$set(this.workspaces, index, newObj);
/*                  let newObj = Object.assign({}, this.workspaces);
                  this.setWorkspaces(_.values(newObj)) */

          };

          reader.readAsDataURL(files[0]);
        }
      },
      mounted() { 
        var parent = document.querySelector('#parent');

        var picker = new window.Picker({
          parent: parent,
          color: (this.currentWorkspace.color) ? this.currentWorkspace.color : 'rgb(53, 59, 72)',
          popup: 'top',
          editorFormat: 'hex'
        });

          // You can do what you want with the chosen color using two callbacks: onChange and onDone.
          picker.onChange = (color) => {
              this.color = color.rgbString
              this.currentWorkspace.color = color.rgbString
          };


$('.acbeni')
  .popup({
    inline: true
  })
;

        },
      created(){
        this.color = (this.currentWorkspace.color) ? this.currentWorkspace.color : 'rgb(53, 59, 72)'

      }
	}
</script>

<template>

  <div style="height: 100%;" class="ui grid stackable">
    <div v-if="!currentWorkspace" style="position: absolute; top: 50%;left:45%;">
        <span style="font-size: 26px;"> ⏳ loading . . . </span>
    </div>

    <div style="height: 100%; background: #f3f3f3;" class="sixteen wide computer sixteen wide mobile column">
      <div class="ui grid">
        <div class="ten wide column centered">
                <h1>Workspace Settings</h1>
                <div class="ui divider"></div>
                <div style="background: transparent;" class="ui basic segment">
                  <form class="ui form">
                    <div  class="field">
                      <img @click="upload()" style="width: 110px; height: 110px; border-radius: 10px;" class="ui small circular centered image" :src="image">
                      <div style="margin-top: 1rem;" class="ui mini fluid button" @click="upload()">Select image from computer</div>
                      <input id="upload" class="ui basic button" type="file" @change="onFileChange($event)" style="display: none;">
                    </div>
                    <div class="field">
                      <label>Workspace Name</label>
                      <input type="text" name="workspace" v-model="currentWorkspace.name" placeholder="Dave's workspace">
                    </div>
                    <div class="field">
                      <label>Workspace Color</label>
                      <div id="parent">
                        <div style="width: 100%; height: 40px;border-radius: 0.3rem; cursor:pointer;" :style="{'background': color}"></div>
                      </div>
                    </div>
                    <div style="text-align: right;" class="field">
                        <div :class="(loading) ? 'loading' : ''" class="ui black icon button" @click="update()">Update</div>
                    </div>
                  </form>
                </div>




<div style="margin-top: 10rem;" class="ui basic segment">
      
     
              <div v-show="workspaces.length != 1" @click="deleteWorkspace(currentWorkspace, null)" class="ui fluid icon basic button"><i class="trash icon"></i> Delete Workspace Permanently</div>
                <div v-if="currentWorkspace._id == showMenu.deleteWs" style="border-bottom: 2px solid rgba(255,255,255, .6); display: block; padding: 1rem 0;">
                  <p>All the channels and settings also will be deleted, Are you sure? </p>
                  <div class="ui mini fluid buttons">
                    <button style="background: transparent;" v-on:click.stop @click="deleteWorkspace(currentWorkspace, 'no')" class="ui button active">No</button>
                    <button v-on:click.stop @click="deleteWorkspace(currentWorkspace, 'yes')" class="ui red button">Yes</button>
                  </div>
                </div>
    
</div>


        </div>
      </div>
      </div>

</div>


</template>

<style scoped>

.checkboxInput {
    margin: 0 0 10px;
    cursor: pointer;
}

.checkboxInput {
    display: -webkit-box;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    flex-direction: row;
    -webkit-box-align: center;
    align-items: center;
    cursor: pointer;
    -webkit-transition: all .1s ease-in-out;
    transition: all .1s ease-in-out;
}

.checkboxInput .checkbox {
    display: -webkit-box;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    min-width: 16px;
    width: 18px;
    height: 18px;
    border: 2px solid 
    #ddd;
    border-radius: 5px;
    -webkit-transition: all .1s ease-in-out;
    transition: all .1s ease-in-out;
    position:relative;
}

.checkboxInput .checkbox .icon-check {
    font-size: 10px;
    color: #aaa;
    opacity: 0;
    -webkit-transition: all .1s ease-in-out;
    transition: all .1s ease-in-out;
    -webkit-transform: translate(18%, -50%);
    transform: translate(-50%, -50%);
    position: absolute;
    left: 50%;
    bottom: 25%;
    height: 12px;
    top: 25%;
}
.checkboxInput .checkboxLabel {
    margin: 0 10px;
    font-size: 15px;
    line-height: 20px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    height: 22px;
}

.checkboxInput:hover .checkbox .icon-check {
    opacity: .3;
}

.checkboxInput .checkbox.checked .icon-check {
    color: #3960BD;
    opacity: 1;
}

.checkboxInput .checkbox.checked {
    border-color: #3960BD;
}

.modalWrapper {
   position: fixed; 
   top: 0; 
   right: 0; 
   bottom: 0; 
   left:0; 
   z-index: 9999; 
   overflow-x: hidden;
   overflow-y: scroll;
}
.modal {
   position: fixed; 
   top: 0; 
   right: 0; 
   bottom: 0; 
   left:0; 
   background: rgba(15, 17, 26, 0.35) none repeat scroll 0% 0%; 
   z-index: 9999; 
   overflow-x: hidden;
   overflow-y: scroll;
}

.radiusSegment {
  border-radius: 5px !important;
}

.cloud {
position: fixed;
background: rgba(0, 0, 0, 0.28) none repeat scroll 0% 0%;
left: 0px;
top: 0px;
bottom: 0px;
right: 0px;
z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Workspace.vue